import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Controls from '../components/FormsUI';
import { useAuth } from '../utility/auth';
import UserController from '../controller/UserController';
import MastersController from '../controller/MastersController';
import CustomizedSnackbars from '../components/Alert';
import EditIcon from '@mui/icons-material/Edit';
import Load from '../components/FormsUI/Loader/index';
import DeleteIcon from '@mui/icons-material/Delete';
import '../css/style.css';
import PDFLoader from "../assets/images/loader.gif";
import { tokens } from '../theme';
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
  Radio,
  FormControlLabel,
} from '@mui/material';
import ExceptionHandlerController from '../controller/ErrorLogsController';
const numberRegEx = /^[0-9\b]+$/;
const INITIAL_FORM_STATE = {
  userName: '',
  userType: '',
  userRoleId: '',
  userReportingRole: '',
  employeeCode: '',
  email: '',
  mobile: '',
  requiresLogin: '',
  referralLink: '',
  referralURL: '',
  // userBranchName: '',
  servicesMapped: [],
  // password: '',
};

const FORM_VALIDATION = Yup.object().shape({
  userName: Yup.string()
    .matches(/^[A-Za-z ]*$/, 'User name is not in correct format')
    .trim('No white space allowed')
    .strict(true)
    .min(3)
    .max(100, 'Name should not be exceed 50 Character')
    .required('User name is required'),
  userType: Yup.string().required('User type is required'),
  userRoleId: Yup.string().required('Role is required'),
  userReportingRole: Yup.string().required('Reporting user is required'),
  employeeCode: Yup.string()
    .min(2)
    .max(20, 'Employee Code should not be exceed 20 Character')
    .trim('No white space allowed')
    .strict(true)
    .matches(/^[A-Za-z0-9]*$/, 'Employee code is not in correct format')
    .required('Employee code is required'),
  email: Yup.string()
    .trim('No white space allowed')
    .strict(true)
    .email('Invalid Email Id')
    .required('Email Id is required'),
  mobile: Yup.number()
    .required('Mobile is required')
    .min(1000000000, 'Invalid mobile number')
    .max(9999999999, 'Invalid mobile number'),
  requiresLogin: Yup.boolean().required('Requires login is required'),
  // userBranchName: Yup.string()
  //   .min(3)
  //   .max(100, 'BranchName should not be exceed 100 Character')
  //   .trim('No white space allowed')
  //   .strict(true)
  //   .matches(/^[A-Za-z ]*$/, 'Branch name is not in correct format')
  //   .required('Branch name is required'),

});

let userTypeOptions = [
  { value: 'Employee', label: 'Employee' },
  { value: 'External', label: 'External' },
];
let requestType = '';
const User = () => {
  const userController = new UserController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem('user'));
  const { data, token } = user;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [rolesValue, setRolesValue] = useState(null);
  const [reportingRolesValue, setReportingRolesValue] = useState(null);
  const [loader, setLoader] = useState(true);
  const [userTypeddl, setUserTypeddl] = useState(null);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [alert, setAlert] = useState({ counter: 0, type: '', msg: '' });
  const [popup, setPopUp] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([]);
  const [reportingUsersOptions, setReportingUsersOptions] = useState([{ label: 'Self', value: '68affcbd55afd7f3779f9d05' }]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [numberMinMax, setNumberMinMax] = useState({ mobile: '' });
  const [roleHierarchyMap, setRoleHierarchyMap] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllUsers = async () => {
    let caughtError;
    try {
      const response = await userController.getAllUsers(token, tenantId);
      if (response.status === 200) {
        const userData = response?.data?.body?.map((item) => {
          item.referralURL = !item.referralURL ? '' : item.referralURL;
          item.login = item.requiresLogin ? 'YES' : 'NO';

          const { userId: id, ...rest } = item;
          return { id, ...rest };
        });
        setReportingUsersOptions(
          (response?.data?.body.length >= 1
            ? response.data.body.map(item => ({
              value: item.userReportingRoleId,
              label: item.userReportingRole,
            }))
            : [])
        );
        setAllUsers(userData);
      } else if (response?.data?.status === 404) {
        showAlert('error', response?.data?.message);
      } else if (response?.status === 500) {
        showAlert('error', response?.response?.data?.message);
      }
      setLoader(() => false);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: 'User get all method',
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const getRolesDD = async () => {
    userController.GetRoles(token, tenantId).then((result) => {
      setLoader(() => false);
      if (result?.status === 200) {
        const roleData = result?.data?.body;
        const roles = [];
        if (roleData.length >= 1) {
          roleData?.map((item) =>
            roles.push({ label: item?.roleName, value: item?.id }))
        }
        setRolesOptions(() => roles);
        setRoleHierarchyMap(roleData);
      }
    });
  };

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const columns = [
    {
      headerName: 'ID',
      field: 'id',
      hide: true,
      filterable: false,
      width: 210,
    },
    { headerName: 'User Name', field: 'userName', width: 210 },
    { headerName: 'User Type', field: 'userType', width: 210 },
    { headerName: 'User Role', field: 'userRoleName', width: 210 },
    { headerName: 'Requires Login', field: 'login', width: 210 },
    {
      field: 'action',
      headerName: 'Action',
      width: 210,
      sortable: false,
      filterable: false,
      disableExport: true,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: '', msg: '' });
            const currentRow = params?.row;
            if (type === 'Edit') {
              requestType = 'Edit';
              setUpdatedValues(() => currentRow);
              setNumberMinMax((prev) => ({
                ...prev,
                mobile: currentRow?.mobile,
              }));
              const currentRowData = currentRow;
              setUpdatedValues(() => ({
                ...currentRowData,
                userReportingRole: currentRow?.userReportingRoleId || currentRow?.userRoleId,
              }));
              setRolesValue({ value: currentRow?.userRoleId, label: currentRow?.userRoleName });
              setReportingUsersOptions([{
                value: currentRow?.userReportingRoleId ?? "68affcbd55afd7f3779f9d05",
                label: currentRow?.userReportingRole ?? "Self",
              }]);
              setReportingRolesValue({
                value: currentRow?.userReportingRoleId ?? "68affcbd55afd7f3779f9d05",
                label: currentRow?.userReportingRole ?? "Self",
              });

              const userTypeLabel = userTypeOptions.filter(
                (item) => item?.value === currentRowData?.userType,
              )[0];
              setUserTypeddl(() => userTypeLabel);
              handleData();
            } else {
              userController
                .Delete(currentRow.id, token)
                .then((response) => {
                  if (response.status === 200) {
                    showAlert('success', 'Deleted successfully');
                    setAllUsers((i) => {
                      return allUsers.filter((item) => item?.id !== currentRow.id);
                    });
                  } else if (response.data.status === 204) {
                    showAlert('error', response.data.message);
                  } else if (response?.status === 500) {
                    showAlert('error', response?.response?.data?.message);
                  }
                })
                .catch((error) => {
                  showAlert('error', 'Oops something went wrong.');
                  setTimeout(() => {
                    setAlert({ counter: 0, type: '', msg: '' });
                  }, 10000);
                });
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: 'User onClick(Edit) method' };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={2}>
            <>
              <IconButton onClick={(e) => onClick(e, 'Edit')}>
                <EditIcon type="button" color="primary" id="Edit" />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="secondary"
                  id="Delete"
                  onClick={(e) => onClick(e, 'Delete')}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const AddUser = async () => {
    getRolesDD();
    setNumberMinMax((prev) => ({ mobile: '' }));
    requestType = 'Add';
    setUpdatedValues(() => INITIAL_FORM_STATE);
    setUserTypeddl(() => null);
    setRolesValue(() => null);
    setReportingRolesValue(() => null);
    // setRolesOptions(() => roles);
    handleData();
  };

  const submitValues = async (submitValueData) => {
    if (isSubmitting) return; // Prevent multiple clicks

    setIsSubmitting(true);
 
    const submitData = {
      tenantId,
      userName: submitValueData?.userName,
      userType: submitValueData?.userType,
      userRoleId: submitValueData?.userRoleId,
      userReportingRole: submitValueData?.userReportingRole,
      employeeCode: submitValueData?.employeeCode,
      email: submitValueData?.email,
      mobile: Number(submitValueData?.mobile),
      requiresLogin: submitValueData?.requiresLogin,
      // userBranchName: submitValueData?.userBranchName,
    };

    try {
      let response;
      if (requestType === "Edit") {
        submitData.userId = submitValueData?.id;
        response = await userController.Update(submitData, token);
      } else {
        response = await userController.Create(submitData, token);
      }

      if (response?.status === 200 || response?.status === 201) {
        showAlert("success", response?.data?.message);
        handlePopup(false);
        getAllUsers();
      } else if (response?.response?.status === 409) {
        showAlert("error", response?.response?.data?.message);
      } else {
        showAlert("error", "Unexpected error occurred.");
      }
    } catch (error) {
      showAlert("error", "Oops something went wrong.");
    } finally {
      // ✅ Always re-enable submission here
      setIsSubmitting(false);
      setLoader(false);
      setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
    }
  };
  const handlePopup = (value) => {
    setPopUp(() => value);
    setReportingUsersOptions([]);
    setReportingUsersOptions(allUsers?.map(item => ({
      value: item.userReportingRoleId,
      label: item.userReportingRole,
    })));
  };
  const handleData = () => setPopUp(() => true);
  if (loader) return <Load />;

  return (
    <>
      <Box
        sx={{
          '& .formBg': {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          '& li.MuiBreadcrumbs-li h6': { color: `${colors.primary[200]}` },
          '& .MuiGrid-root.Mui-heading h2': {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Settings</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>User</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className="adduser">
            <Controls.ActionButton onClick={() => AddUser()}>
              <span>Add New</span>
            </Controls.ActionButton>
          </Grid>
          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Controls.Grid columns={columns} data={allUsers} fileName={'Users'} />
                {popup && (
                  <Controls.Popup title="User Details" openPopup={popup} setOpenPopup={handlePopup}>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || INITIAL_FORM_STATE),
                      }}
                      validationSchema={FORM_VALIDATION}
                      onSubmit={(values) => submitValues(values)}
                    >
                      {({ values, setFieldValue }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                id="userRoleId"
                                name="userRoleId"
                                options={rolesOptions}
                                label="Role"
                                value={rolesValue}
                                onChange={(event, value) => {
                                  if (value) {
                                    const selectedRoleId = value?.value;
                                    setFieldValue('userRoleId', selectedRoleId);
                                    setRolesValue(() => value);

                                    const selectedRole = roleHierarchyMap.find(r => r.id === selectedRoleId);
                                    const reportingToRoleId = selectedRole?.reportingToId;

                                    // Get current editing user ID to exclude
                                    const currentUserId = updatedValues?.id;

                                    // Filter users who have the reporting role but exclude the current user
                                    const reportingUsers = allUsers
                                      .filter(user => user.userRoleId === reportingToRoleId && user.id !== currentUserId)
                                      .map(user => ({
                                        label: user?.userName,
                                        value: user?.id,
                                      }));

                                    const updatedReportingUsers = [
                                      { label: 'Self', value: '68affcbd55afd7f3779f9d05' },
                                      ...reportingUsers,
                                    ];
                                    setReportingUsersOptions(updatedReportingUsers);
                                    setReportingRolesValue(null);
                                    setFieldValue('userReportingRole', '');
                                  }
                                }}
                                autoFocus
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                id="userReportingRole"
                                name="userReportingRole"
                                options={reportingUsersOptions}
                                label="Reporting User"
                                value={reportingRolesValue}
                                onChange={(event, value) => {
                                  if (value !== undefined && value !== null && value !== '') {
                                    setFieldValue('userReportingRole', value?.value);
                                    setReportingRolesValue(() => value);
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                id="userType"
                                name="userType"
                                options={userTypeOptions}
                                label="User Type"
                                value={userTypeddl}
                                onChange={(event, value) => {
                                  if (value) {
                                    setFieldValue('userType', value?.value);
                                    setUserTypeddl(() => value);
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="userName"
                                label="Name"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="userBranchName"
                                label="Branch Name"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="employeeCode"
                                label="Employee Code"
                                type="string"
                                inputProps={{ maxLength: 20 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield name="email" label="Email Id" type="string" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="mobile"
                                label="Mobile"
                                type="string"
                                value={numberMinMax.mobile}
                                inputProps={{ maxLength: 10 }}
                                placeholder="9999999999"
                                onChange={(e) => {
                                  const { value } = e.target;
                                  if (numberRegEx.test(value) || value === '') {
                                    setNumberMinMax((prev) => ({
                                      ...prev,
                                      mobile: value,
                                    }));
                                    setFieldValue('mobile', value);
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              Requires Login
                              <Controls.RadioButton name="requiresLogin" row>
                                <FormControlLabel
                                  vertical-align="middle"
                                  value={true}
                                  control={<Radio />}
                                  label="YES"
                                  disabled={values?.userRoleId === 1}
                                />
                                <FormControlLabel
                                  vertical-align="middle"
                                  value={false}
                                  control={<Radio />}
                                  label="NO"
                                  disabled={values?.userRoleId === 1}
                                />
                              </Controls.RadioButton>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid item xs={4} md={2} className="marginAuto">
                                {isSubmitting ? (
                                  <img
                                    src={PDFLoader}
                                    width={57}
                                    alt="Loading"
                                    style={{ marginLeft: "7px" }}
                                  />
                                ) : (
                                  <Controls.Button>Submit</Controls.Button>
                                )}
                              </Grid>
                            </Grid>
                            {/* <Grid item xs={4} md={2} className="marginAuto">
                              <Controls.Button>Submit</Controls.Button>
                            </Grid> */}
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Controls.Popup>
                )}
              </div>
            </Container>
          </Grid>
          {alert?.counter > 0 && (
            <CustomizedSnackbars status={alert?.counter} msg={alert?.msg} type={alert?.type} />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default User;
